import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { StoreProvider } from "@/context/StoreContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import Dashboard from "@/pages/Dashboard";
import NuovoGiorno from "@/pages/NuovoGiorno";
import Registro from "@/pages/Registro";
import Riconciliazioni from "@/pages/Riconciliazioni";
import StoricoMesi from "@/pages/StoricoMesi";
import Report from "@/pages/Report";
import Impostazioni from "@/pages/Impostazioni";
import Utenti from "@/pages/Utenti";
import Audit from "@/pages/Audit";
import PuntiVendita from "@/pages/PuntiVendita";
import PublicHome from "@/pages/PublicHome";

function LoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <img src="/logo_icon.png" alt="PG" className="h-14 w-14 animate-pulse rounded-xl" />
    </div>
  );
}

function Protected({ children, superOnly }) {
  const { user } = useAuth();
  if (user === null) return <LoadingScreen />;
  if (user === false) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/cambia-password" replace />;
  if (superOnly && user.role !== "super_admin") return <Navigate to="/" replace />;
  return (
    <StoreProvider>
      <Layout>{children}</Layout>
    </StoreProvider>
  );
}

// Rotta "/": home pubblica per i visitatori, gestionale per gli utenti autenticati.
function RootRoute() {
  const { user } = useAuth();
  if (user === null) return <LoadingScreen />;
  // Home pubblica sempre accessibile: anche l'utente con cambio password obbligatorio
  // vede la home (nessun redirect forzato a /cambia-password qui).
  if (user === false) return <PublicHome />;
  if (user.must_change_password) return <PublicHome />;
  return (
    <StoreProvider>
      <Layout><Dashboard /></Layout>
    </StoreProvider>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/cambia-password" element={<ChangePassword />} />
      <Route path="/" element={<RootRoute />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/nuovo-giorno" element={<Protected><NuovoGiorno /></Protected>} />
      <Route path="/registro" element={<Protected><Registro /></Protected>} />
      <Route path="/riconciliazioni" element={<Protected><Riconciliazioni /></Protected>} />
      <Route path="/storico" element={<Protected><StoricoMesi /></Protected>} />
      <Route path="/report" element={<Protected><Report /></Protected>} />
      <Route path="/punti-vendita" element={<Protected superOnly><PuntiVendita /></Protected>} />
      <Route path="/utenti" element={<Protected superOnly><Utenti /></Protected>} />
      <Route path="/audit" element={<Protected superOnly><Audit /></Protected>} />
      <Route path="/impostazioni" element={<Protected><Impostazioni /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
